import { Component } from '@theme/component';

/** @extends {Component<{tabs: HTMLButtonElement[], panels: HTMLElement[], storyMedia: HTMLElement[], tablist: HTMLElement}>} */
class LumenelleValues extends Component {
  #selectedIndex = 0;
  connectedCallback() {
    super.connectedCallback();
    this.enhance();
  }

  updatedCallback() {
    super.updatedCallback();
    this.enhance();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  enhance() {
    this.refs.tablist?.setAttribute('role', 'tablist');
    this.refs.tablist?.setAttribute('aria-orientation', this.dataset.tabOrientation || 'vertical');
    for (const tab of this.refs.tabs || []) tab.setAttribute('role', 'tab');
    for (const panel of this.refs.panels || []) panel.setAttribute('role', 'tabpanel');
    this.select(Math.min(this.#selectedIndex, Math.max(0, (this.refs.tabs?.length || 1) - 1)));
  }

  select(index) {
    this.#selectedIndex = index;
    for (const media of this.refs.storyMedia || []) {
      media.hidden = Number(media.dataset.index) !== index;
    }
    const tabs = this.refs.tabs || [];
    for (const [i, tab] of tabs.entries()) {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      const panel = this.refs.panels?.[i];
      if (panel) panel.hidden = i !== index;
    }
  }

  /** @param {MouseEvent} event */
  selectStory(event) {
    const tab = event.target instanceof Element ? event.target.closest('button[data-index]') : null;
    if (tab && this.contains(tab)) this.select(Number(tab.dataset.index));
  }

  nextStory() {
    const tabs = this.refs.tabs || [];
    if (!tabs.length) return;
    const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    this.select((current + 1) % tabs.length);
  }

  /** @param {KeyboardEvent} event */
  handleKeydown(event) {
    const tabs = this.refs.tabs || [];
    if (!(event.target instanceof HTMLButtonElement) || !tabs.length) return;
    let index = Number(event.target.dataset.index);
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (index + tabs.length - 1) % tabs.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else return;
    event.preventDefault();
    this.select(index);
    tabs[index]?.focus();
  }
}

if (!customElements.get('lumenelle-values-component')) customElements.define('lumenelle-values-component', LumenelleValues);
